import React from 'react'
import './help-section-slider.pure.css'

const HelpSectionSliderSectionItemPure = (props) => {
    const { helpSection, onSelectHelpSection } = props
    return (
        <div className="helpSecionPanelItem-item" onClick={() => { onSelectHelpSection(helpSection) }}>
            <div className="helpSecionPanelItem-item-group">
                <span className="helpSecionPanelItem-item-group-img">
                    <img src={helpSection.icon} width={16} alt="icono de sección"/>
                </span>
                <span>{helpSection.name}</span>
            </div>
        </div>
    )
}
export { HelpSectionSliderSectionItemPure as default }